/* eslint-disable @typescript-eslint/no-explicit-any */
import { logger } from '../features/logger';
import { templateMap as templateMapEmea } from '../templates/form/emea/default/geos/create';
import { templateMap as templateMapLatam } from '../templates/form/latam/default/geos/create';
import { templateMap as templateMapNa } from '../templates/form/na/us/geos/create';
import {
  HEADER_SUBTITLE_TRANSLATION_KEYS,
  HEADER_TITLE_TRANSLATION_KEYS,
  PAGE_ROUTES
} from './constants';
import { updateSessionStorage } from './storage';

export function getHeaderFromPath(
  t: any,
  firstName = '',
  pathname = '',
  recordType = '',
  customerIdentity = 'Penelope'
) {
  const splittedPath = pathname?.split('/');
  const pagePath = splittedPath[splittedPath.length - 1];

  switch (pagePath) {
    case PAGE_ROUTES.company:
      return {
        title: `${t(HEADER_SUBTITLE_TRANSLATION_KEYS.welcome)}, ${firstName} `,
        subtitle: t(HEADER_SUBTITLE_TRANSLATION_KEYS.company)
      };

    case PAGE_ROUTES.financial:
      if (PAGE_ROUTES.financial && recordType === 'Payer') {
        return {
          title: `${t(HEADER_SUBTITLE_TRANSLATION_KEYS.welcome)}, ${firstName} `,
          subtitle: t(HEADER_SUBTITLE_TRANSLATION_KEYS.company)
        };
      } else {
        return { title: t(HEADER_TITLE_TRANSLATION_KEYS.financial) };
      }

    case PAGE_ROUTES.shipTo:
      if (PAGE_ROUTES.financial && recordType === 'Ship To') {
        return {
          title: `${t(HEADER_SUBTITLE_TRANSLATION_KEYS.welcome)}, ${firstName} `,
          subtitle: t(HEADER_SUBTITLE_TRANSLATION_KEYS.company)
        };
      } else {
        return { title: t(HEADER_TITLE_TRANSLATION_KEYS.shipTo) };
      }

    case PAGE_ROUTES.review:
      return {
        title: t(HEADER_TITLE_TRANSLATION_KEYS.review),
        subtitle: t(HEADER_SUBTITLE_TRANSLATION_KEYS.review)
      };

    case PAGE_ROUTES.dashboard:
      return {
        title: `${t(HEADER_SUBTITLE_TRANSLATION_KEYS.welcome)}, ${customerIdentity}`
      };

    default:
      return { title: '' };
  }
}

export async function singleRecordCustomer(requests: any[], location: any, history: any) {
  updateSessionStorage.setItem('hcId', requests[0].id);

  if (location.pathname === '/secure/form/shipTo') {
    await history.push('/secure/form/shipTo');
  } else if (location.pathname === '/secure/form/financial') {
    await history.push('/secure/form/financial');
  } else if (location.pathname === '/secure/form/review') {
    await history.push('/secure/form/review');
  } else {
    await history.push('/secure/form');
  }
}

function getLatamCountryCode(countryCode: string) {
  const countryArray = ['mx', 'br'];
  return countryArray.includes(countryCode) ? countryCode : 'default';
}

function getEmeaCountryCode(countryCode: string) {
  const countryArray = ['tr', 'eu'];
  return countryArray.includes(countryCode) ? countryCode : 'default';
}

export function getFormTemplateFromCustomer(customer: any = {}) {
  const {
    region = '',
    countryCode = '',
    requestType = '',
    recordType = '',
    business = ''
  } = customer;

  let currentTemplateMap: any;
  let countryGroup: string;
  let businessGroup: string;

  const formattedRegion = region.toLowerCase();

  if (formattedRegion === 'emea' && business.includes('CBI')) {
    businessGroup = 'cbi';
  } else if (formattedRegion === 'emea' && business.includes('GEOS')) {
    businessGroup = 'geos';
  } else if (formattedRegion === 'emea' && business.includes('CSST')) {
    businessGroup = 'csst';
  } else if (formattedRegion === 'latam' && business.includes('CBI')) {
    businessGroup = 'cbi';
  } else {
    businessGroup = 'geos';
  }

  switch (formattedRegion) {
    case 'na':
      currentTemplateMap = templateMapNa;
      countryGroup = 'us';
      break;

    case 'latam':
      currentTemplateMap = templateMapLatam;
      countryGroup = getLatamCountryCode(countryCode.toLowerCase());
      break;

    case 'emea':
      currentTemplateMap = templateMapEmea;
      countryGroup = getEmeaCountryCode(countryCode.toLowerCase());
      break;

    default:
      currentTemplateMap = templateMapNa;
      countryGroup = countryCode.toLowerCase();
  }

  const defaultMap = currentTemplateMap['customer_set_up'];

  // ✅ UPDATED: support both .ts and .js
  const modules = import.meta.glob('../templates/form/**/*.{ts,js}', {
    eager: true
  }) as Record<string, any>;

  try {
    const pathTs = `../templates/form/${formattedRegion}/${countryGroup}/${businessGroup}/${requestType.toLowerCase()}.ts`;
    const pathJs = `../templates/form/${formattedRegion}/${countryGroup}/${businessGroup}/${requestType.toLowerCase()}.js`;

    const jsTemplateFile = modules[pathTs] || modules[pathJs];

    if (!jsTemplateFile) {
      throw new Error(`Template not found for path: ${pathTs}`);
    }

    const templateMap = jsTemplateFile.templateMap || jsTemplateFile.default?.templateMap;

    return (
      templateMap?.[recordType.replace(/ /g, '_').toLowerCase()] ||
      defaultMap
    );
  } catch (error) {
    logger.error('Error in getFormTemplateFromCustomer', { error });
    return defaultMap;
  }
}